import { Theme, makeStyles } from "@material-ui/core";
import { ComponentProps } from "react";
import Typography from "./Typography";

export const useStyles = makeStyles<Theme, ComponentProps<typeof Typography>>(
  () => ({
    underline: ({ underline }) => ({
      textDecoration: underline ? "underline" : "initial",
    }),
  }),
);
